export default angular.module("mars.vet.dnareports.controllers.breed",[]).controller('BreedTestsController', function($rootScope, $scope, $window, $http, $routeParams,
    EntryService, ImageService, NavigationService, FileService, EntryIDService,reportdata) {
      'ngInject';
      let resultString = reportdata.resultString;
      let sampleDetails = reportdata.sampleDetails;
    $scope.breedTests = resultString.resultPbDd !== undefined && resultString.resultPbDd.length > 0;
    var resultPbDdBreed = resultString.resultPbDdBreed;
    var breedName1 = "";
    var breedName2 = "";
    var pbDd = "";

    if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
        breedName1 = resultPbDdBreed[0]['breed_1'];
        breedName2 = resultPbDdBreed[0]['breed_2'];
        pbDd = resultPbDdBreed[0]['type'] == "Wisdom_PB" ? "PB" : resultPbDdBreed[0]['type'] == "Wisdom_DD" ? "DD" : "";
    }
    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }
    EntryService.getEntry(EntryIDService.getEntryID('Breed Tests')).then(function(response) {

        var fields = response.fields;
        if (reportType != 'pdf') {
            $rootScope.pageTitle = fields.title;
        }
        $scope.title = fields.title;
        $scope.caption = fields.caption;

        var boBreed = resultString['boBreed'];

        if (boBreed !== undefined && boBreed != '') {
            $scope.boBreedList = boBreed !== undefined && boBreed != '' ? boBreed.split(",") : "";
            $scope.boBreed = boBreed;
        }

        $scope.pbddDropDowns = pbDd == 'PB' ? fields.pureBreedDropDowns : pbDd == "DD" ? fields.designerDogDropDowns : "";

        $scope.pcaBlocksList = [];
        $scope.pbddBreedList = [];
        var resultPbDdData = [];
        var resultPbDdData = resultString.resultPbDd;
        $scope.description = "";
        $scope.sampleID = resultString.sampleID;
        resultPbDdData.push({
            "evidence": 'notexpected',
            "outcome": 'POSITIVE'
        });
        var status;
        var style;
        var cssClass;
        var outcomeFinal;
        var buildDropDown = [];
        if (reportType != 'pdf') {
            buildDropDown.push('ancestry_chart');
        }
        buildDropDown.push('pca_breed');
        buildDropDown.push('pca_all');

        if (pbDd == 'PB') {
            buildDropDown.push('pca_nextbreed');
            buildDropDown.push('pairwise_distance');
            buildDropDown.push('pairwise_distance_topn');
        } else if (pbDd == 'DD') {
            buildDropDown.push('structure');
        }
        buildDropDown.push('homozygosity');
        if (reportType != 'pdf') {
            buildDropDown.push('notexpected');
        }
        var imageFileName;

        //buildDropDown for re arranging the evidences order
        angular.forEach(buildDropDown, function(value, key) {
            //pbddDropDowns holds the contentful the data
            angular.forEach($scope.pbddDropDowns, function(pbddData, evidence) {
                if (value == evidence) {
                    //resultPbDdData holds the json data
                    angular.forEach(resultPbDdData, function(resultSet, key) {

                        if (resultSet['evidence'].trim() == 'final_outcome') {
                            outcomeFinal = resultSet['outcome'];
                        }
                        var desc;
                        var statusDesc;


                        if (evidence == resultSet['evidence'].trim()) {
                            if (resultSet['outcome'] == 'POSITIVE') {
                                status = "PASS";
                            } else if (resultSet['outcome'] == 'NEGATIVE') {
                                status = "FAIL";
                            } else if (resultSet['outcome'] == 'UNCERTAIN') {
                                status = "INCONCLUSIVE";
                            }

                            if (evidence == 'notexpected') {
                                status = "";
                                style = ""
                                cssClass = "";
                            }
                            var imgName = "";
                            if (pbDd == 'PB') {
                                if (evidence == 'homozygosity') {
                                    imgName = 'HOMOZYGOSITY.png';
                                } else if (evidence == 'pca_nextbreed') {
                                    imgName = 'PCA_NEXTBREED.png';
                                }
                            }
                            if (evidence == 'pca_all') {
                                imgName = 'PCA_ALL.png';
                            } else if (evidence == 'pca_breed') {
                                imgName = 'PCA_BREED.png';
                            } else if (evidence == 'ancestry_chart') {
                                imgName = 'ancestrychart.png';
                            }

                            var repeatFlag = true;
                            //TO avoid adding not expected multiple times
                            angular.forEach($scope.pcaBlocksList, function(value, key) {
                                if (value['Box'] == 'notexpected') {
                                    repeatFlag = false;
                                }
                            });

                            if (resultSet['outcome'] != 'NORESULT') {
                                if (pbDd == 'PB') {
                                    desc = pbddData['Description'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", breedName1);
                                    statusDesc = pbddData[resultSet['outcome']].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", breedName1);
                                } else if (pbDd == 'DD') {
                                    desc = pbddData['Description'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
                                    statusDesc = pbddData[resultSet['outcome']].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
                                }
                                if (repeatFlag) {
                                    $scope.pcaBlocksList.push({
                                        "Box": evidence,
                                        "Title": pbddData['Title'].trim(),
                                        "Description": desc + statusDesc,
                                        'StatusWiseDesc': statusDesc,
                                        'Status': status,
                                        'ColorCode': style,
                                        'pcaImage': imgName
                                    });
                                }
                            }
                        }
                    });

                }
            });
        });

        if (pbDd == 'PB') {
            $scope.description = fields.pureBreedDescription[outcomeFinal].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", breedName1);
            $scope.pbddBreedList.push(breedName1);
        } else if (pbDd == 'DD') {

            $scope.description = fields.designerDogDescription[outcomeFinal].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
            $scope.pbddBreedList.push(breedName1);
            $scope.pbddBreedList.push(breedName2);
        }
        $scope.pbddFlag = pbDd;

        $scope.imgPath = "/staticresources/dnareports/images/" + resultString.sampleID;

        NavigationService.setNavigationUrls();
        $window.ga('send', 'pageview', {
            'page': $rootScope.pageTitle
        });
    }, function(error) {
        // promise rejected, could log the error with:
        // console.log('error', error);
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/breedtests.controller.js